<template>
  <FormContainer :title="$t('title.settings')" :onSubmit="onSubmit">
    <FormItem>
      <b-select expanded v-validate="'required'" v-model="settings.language" name="language">
        <option v-for="option in languages" :value="option.key" :key="option.key">
          {{ option.title }}
        </option>
      </b-select>
    </FormItem>
  </FormContainer>
</template>

<script>
import { UPDATE_USERSETTINGS } from '../../store/actions.type'
import DataService from '../../_helpers/data.service'
import { ROOT_API } from '../../_helpers/config'

export default {
  data() {
    return {
      languages: [
        { key: 'tr', title: 'Türkçe' },
        { key: 'en', title: 'English' }
      ],
      settings: { language: null }
    }
  },
  mounted() {
    const userLang = DataService.get('user_lang')
    if (userLang) {
      this.settings.language = userLang
    }
  },
  methods: {
    onSubmit() {
      const userSettings = [{ key: 'Language', value: this.settings.language }]
      const isFake = ROOT_API === 'fake-api'
      if (isFake) {
        this.$root.$i18n.locale = this.settings.language
      } else {
        this.$store.dispatch(UPDATE_USERSETTINGS, userSettings).then(() => {
          this.$root.$i18n.locale = this.settings.language
        })
      }
    }
  }
}
</script>
